import { render } from "./FlowsMenu.vue?vue&type=template&id=00e54664"
import script from "./FlowsMenu.vue?vue&type=script&lang=js"
export * from "./FlowsMenu.vue?vue&type=script&lang=js"
script.render = render

export default script